import { render, staticRenderFns } from "./keywords.vue?vue&type=template&id=2da0ef0c&scoped=true&"
import script from "./keywords.vue?vue&type=script&lang=js&"
export * from "./keywords.vue?vue&type=script&lang=js&"
import style0 from "./keywords.vue?vue&type=style&index=0&id=2da0ef0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da0ef0c",
  null
  
)

export default component.exports